import { render, staticRenderFns } from "./EudrBatchStatusIcon.vue?vue&type=template&id=6ca3f788&"
import script from "./EudrBatchStatusIcon.vue?vue&type=script&lang=js&"
export * from "./EudrBatchStatusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports